export const breadcrumb = {
  title: 'Верификация номеров',
  trunk: {
    index: 'Настройки и тестирование'
  }
};
